import { render, staticRenderFns } from "./userRolePermissions.vue?vue&type=template&id=980014b0&scoped=true&lang=pug"
import script from "./userRolePermissions.vue?vue&type=script&lang=js"
export * from "./userRolePermissions.vue?vue&type=script&lang=js"
import style0 from "./userRolePermissions.vue?vue&type=style&index=0&id=980014b0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980014b0",
  null
  
)

export default component.exports